<template>
<div>
	<section class="content__custom">
		<div class="main-title">
			<h1 class="poll">
				{{ 'sendPoll' | translate }}
			</h1>
			<h2>{{ 'poll-subtitle' | translate | capitalize }}</h2>
		</div>
		<modal v-if="showModal" :title="'confirm-publish-title'" :message="'confirm-publish-text'" :pollId="pollId" v-on:close="pollId=0"></modal>
		<div class="boxes">
			<div class="box">
				<div class="box__container">
					<div class="box__body">
						<form @submit.prevent="registerPoll">
							<div class="form__group">
								<label for="title-poll">{{ 'title' | translate | capitalize }}</label>
								<p class="label-subtitle">{{ 'poll-name-text' | translate | capitalize }}</p>
								<input id="title-poll" type="text"  @input="count($event, 40)" maxlength="40" required v-model="formPollRegister.name">
								<span id="counter-title-poll" class="label pull-right bg-red counter counter-minor"></span>
							</div>
								<div class="has-error" v-show="errorForm(error, 'name')">
									<label class="control-label" for="inputError"><i class="fas fa-times-circle-o"></i> {{ /*'name-exists'*/  errorForm(error, 'name') | translate | capitalize }}</label>
								</div>
							<div class="form__group">
								<label for="questionname">{{ 'question' | translate | capitalize }}</label>
								<p class="label-subtitle">{{ 'example' | translate | capitalize }} {{ 'question-example' | translate | lowercase }}</p>
								<textarea  id="questionname" type="text" v-model="formPollRegister['questions[0]']" @input="count($event, 250)" maxlength="250" required></textarea>
								<span id="counter-questionname" class="label pull-right bg-red counter "></span>
								<div class="has-error" v-show="errorForm(error, 'questions[]')">
									<label class="control-label" for="inputError"><i class="fas fa-times-circle-o"></i> {{ 'required-field' | translate }}</label>
								</div>
							</div>
							<div class="form__group">
								<label for="option1">{{ 'option-one' | translate | capitalize }}</label>
								<p class="label-subtitle">{{ 'example' | translate | capitalize }} {{ 'yes' | translate | lowercase }}</p>
								<input id="option1" type="text"  v-model="formPollRegister[`questions[0][options][0]`]" @input="count($event, 20)" maxlength="20" required>
								<span id="counter-option1" class="label pull-right bg-red counter counter-minor"></span>
							</div>
							<div class="form__group">
								<label for="option2">{{ 'option-two' | translate | capitalize }}</label>
								<p class="label-subtitle">{{ 'example' | translate | capitalize }} {{ 'no' | translate | lowercase }}</p>
								<input id="option2" type="text"  v-model="formPollRegister['questions[0][options][1]']" @input="count($event, 20)" maxlength="20" required>
								<span id="counter-option2" class="label pull-right bg-red counter counter-minor"></span>
							</div>

								<div class="form__group submit__content">
									<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
										{{ 'next' | translate | capitalize }}
									</button>
								</div>
								<div class="form__group has-success text-center">
									<label class="control-label margin-top" for="inputSuccess" v-show="successMsg"><i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}</label>
								</div>
								<div class="has-error" v-show="errorForm(error, 'questions[0]')">
									<label class="control-label margin-top" for="inputError"><i class="fas fa-times-circle-o"></i> {{ 'required-field' | translate | capitalize }}</label>
								</div>
							</form>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>
</template>

<script>
	import alert from '../../components/alert/alert.vue';
	import error from '../../methods/errors';
	import modal from '../../components/modal/modal.vue';

	export default {
		name: 'newresearch',
		components: {
			alert,
			modal,
		},
		data() {
			return {
				session: {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
				},
				formPollRegister: {
					question: [],
				},
				successMsg: false,
				pollId: 0,
				error: {},
				showModal: false,
				groupsToFilterNotification: {},
				groupsFilterToSendNotification: [],
				sendTo: 'all',
				filterExists: '',
				submitLoading: false,

			};
		},
		computed: {
			success() {
				return this.$store.state.status;
			},
			allPoll() {
				return this.$store.state.allPoll;
			},
			pollCreatedId() {
				return this.$store.state.poll.statusId;
			},
			errors() {
				return this.$store.state.error;
			},
			groupCreated() {
				this.groupsToFilterNotification = this.$store.state.group.groups;
			},
		},
		watch: {
			pollCreatedId() {
				this.pollId = this.$store.state.poll.statusId;
			},
			/* eslint-disable object-shorthand */
			errors() {
				this.error = this.$store.state.error;
			},
			groupCreated() {
				return this.$store.state.group.groups;
			},
		},
		methods: {
			toggleSubmitLoading() {
				this.submitLoading = !this.submitLoading;
			},
			count(event, tam) {
				const lengthText = document.getElementById(`counter-${event.target.id}`);
				lengthText.textContent = (event.target.value.length - tam) * -1;
			},
			registerPoll() {
				this.$store.dispatch('setPollRegister', this.formPollRegister)
					.then((response) => {
						this.toggleSubmitLoading();
						this.validate();
						this.$router.push({ name: 'pollsRevision', params: { id: response.data.id } });
					})
					.catch(() => {
						this.toggleSubmitLoading();
					});
			},

			removeFilter(obj) {
				this.groupsFilterToSendNotification.splice(obj, 1);
				this.filterExists = false;
			},
			errorForm(obj, field) {
				const msg = error.errorForm(obj, field);
				return msg;
			},
			validate() {
				if (this.success) {
					this.successMsg = this.success;
					this.$data.formPollRegister = {};
					this.$root.$emit('eventing');
				}
			},
		},

	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/poll/pollsDetails.vue